var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInsure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.09 10H17.637c-2 0-3.618 1.636-3.618 3.636L14 37.146c0 1.254.636 2.363 1.6 3.018L30.364 50l14.745-9.836a3.646 3.646 0 001.6-3.019l.018-23.509c0-2-1.636-3.636-3.636-3.636zM26.728 37.273l-9.09-9.091 2.563-2.564 6.527 6.51 13.8-13.8 2.564 2.581-16.364 16.364z",
    fill: "#E3B05F"
  })));
}

export default SvgInsure;